export var BusinessTransactionChannel;
(function (BusinessTransactionChannel) {
    BusinessTransactionChannel["BANK_ACCOUNT"] = "BANK_ACCOUNT";
    BusinessTransactionChannel["MOBILE_MONEY"] = "MOBILE_MONEY";
    BusinessTransactionChannel["CARD"] = "CARD";
    BusinessTransactionChannel["CRYPTO"] = "CRYPTO";
    BusinessTransactionChannel["VIRTUAL_BANK_ACCOUNT"] = "VIRTUAL_BANK_ACCOUNT";
    BusinessTransactionChannel["POOL_ACCOUNT"] = "POOL_ACCOUNT";
    BusinessTransactionChannel["ACH_BANK_ACCOUNT"] = "ACH_BANK_ACCOUNT";
    BusinessTransactionChannel["INTERAC"] = "INTERAC";
    BusinessTransactionChannel["PAYBILL_TILL"] = "PAYBILL_TILL";
    BusinessTransactionChannel["RFP"] = "RFP";
    BusinessTransactionChannel["UPI"] = "UPI";
    BusinessTransactionChannel["VIRTUAL_CARD"] = "VIRTUAL_CARD";
    BusinessTransactionChannel["SWIFT"] = "SWIFT";
    BusinessTransactionChannel["WE_CHAT"] = "WE_CHAT";
    BusinessTransactionChannel["ALIPAY"] = "ALIPAY";
    BusinessTransactionChannel["PAYMENT_LINQ"] = "PAYMENT_LINQ";
    // Not included in payment method selector
    BusinessTransactionChannel["ADMIN"] = "ADMIN";
    BusinessTransactionChannel["WALLET"] = "WALLET";
})(BusinessTransactionChannel || (BusinessTransactionChannel = {}));
/**
 * Channels that are global by nature: they reach every country, so the
 * destination country is not the corridor. SWIFT terminates in USD to a bank
 * anywhere and CRYPTO to a wallet, so neither is answered by a per-country
 * lookup or closed by a per-country switch.
 *
 * Read by business-web to widen a destination country list, and by the server
 * to skip the per-country corridor gate on a payout. Closing one of these
 * channels is done on its processor corridor (`processor.meta.corridors`) and
 * currency config, not on a country.
 */
export const globalBusinessTransactionChannels = new Set([
    BusinessTransactionChannel.SWIFT,
    BusinessTransactionChannel.CRYPTO,
]);
//# sourceMappingURL=BusinessTransactionChannel.js.map